<template>
    <section class="container-page">
        <div class="container-ourvaluesServices  text-start">
            <NewHero translationKeyHeading="services.careSection.mainTitle"
                translationKeyHeadingsmall="services.careSection.maindesc" />
            <div class="gridServicesInnerSection text-start">
                <div class="Quialityrow">
                    <img src="@/assets/images/services/highlyQualified.png" alt="img" />
                    <h4>{{ $t("services.careSection.title1") }}</h4>
                    <p>{{ $t("services.careSection.desc1") }}</p>
                </div>
                <div class="Quialityrow">
                    <img src="@/assets/images/services/safety.png" alt="img" />
                    <h4>{{ $t("services.careSection.title2") }}</h4>
                    <p>{{ $t("services.careSection.desc2") }}</p>
                </div>
                <div class="Quialityrow">
                    <img src="@/assets/images/services/highLevel.png" alt="img" />
                    <h4>{{ $t("services.careSection.title3") }}</h4>
                    <p>{{ $t("services.careSection.desc3") }}</p>
                </div>
            </div>
            <div class="gridServicesInnerSection text-start">
                <div class="Quialityrow">
                    <img src="@/assets/images/services/market.png" alt="img" />
                    <h4>{{ $t("services.careSection.title4") }}</h4>
                    <p>{{ $t("services.careSection.desc4") }}</p>
                </div>
                <div class="Quialityrow">
                    <img src="@/assets/images/services/storage.png" alt="img" />
                    <h4>{{ $t("services.careSection.title5") }}</h4>
                    <p>{{ $t("services.careSection.desc5") }}</p>
                </div>
                <div class="Quialityrow">
                    <img src="@/assets/images/services/mechanical.png" alt="img" />
                    <h4>{{ $t("services.careSection.title8") }}</h4>
                    <p>{{ $t("services.careSection.desc8") }}</p>
                </div>
            </div>
            <div class="gridServicesInnerSection text-start">
                <div class="Quialityrow">
                    <img src="@/assets/images/services/proper.png" alt="img" />
                    <h4>{{ $t("services.careSection.title6") }}</h4>
                    <p>{{ $t("services.careSection.desc6") }}</p>
                </div>
                <div class="Quialityrow">
                    <img src="@/assets/images/services/customer.png" alt="img" />
                    <h4>{{ $t("services.careSection.title7") }}</h4>
                    <p>{{ $t("services.careSection.desc7") }}</p>
                </div>

            </div>
        </div>
    </section>
</template>
  
<script >
 
import NewHero from "@/components/global/newHero.vue";

export default {
    props: ["translationKey", "link"],
    name: "QualityCard",
    components: {
        NewHero,
    },
} ;
</script>
  
<style lang="scss" scoped>
.container-page {
    padding: 120px 0px 120px 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 1200px) {
        width: 100%;
        max-width: 100%;
    }
}

.container-ourvaluesServices {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 0px 120px 0px;

    @media screen and (max-width: 1200px) {
        padding: 0 24px;
    }
}

.gridServicesInnerSection {
    gap: 48px;
    display: flex;
    align-items: center;
    margin: 24px 0px 0px 0px;
    padding: 0;


    @media screen and (max-width: 1200px) {
        flex-direction: column;
        width: 100% !important;
    }

    .Quialityrow {
        width: 416px;
        height: 281px;
        background: linear-gradient(180deg, #f8f9fb 0%, #ffffff 100%);
        box-shadow: 0px 32px 40px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 24px;

        @media screen and (max-width: 1200px) {
            width: 100% !important;
            height: auto !important;
        }

        @media screen and (max-width: 500px) {
            width: 100% !important;
            height: auto !important;
            margin: 32px 0px;
            padding: 24px;
        }

        img {
            padding: 0;
        }

        h4 {
            background-color: transparent !important;
            font-weight: 500;
            font-size: 18px;
            line-height: 29px;
            color: #363636;
            padding: 16px 0px 16px;
            margin: 0;
        }

        p {
            font-weight: 400;
            font-size: 16px;
            line-height: 140%;
            background-color: transparent !important;
            color: #5d5d5d;
            padding: 0;
            margin: 0;
        }

        img {
            width: 52px;
            height: 52px;
        }
    }
}
</style>
  